import {PermitteeType} from "~/enums/permitteeType";
import Guid from "~/helpers/guid"
import {TagColor} from "~/enums/tagColor";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import LicenseBuilderModel from "../../../../common/models/tracked/licenseBuilderModel";
import LicenseNotification from "./licenseNotification";
import Vue from "vue";
import {IRecipient} from "../../../../common/interfaces/notificationInterfaces";
import LicenseStatusAction from "./licenseStatusAction";

export default class StatusChangeInitiator extends LicenseBuilderModel implements IRecipient {
    client_id: string = Guid.create();
    reference_id: string = null;
    reference_type: number = null;
    first_name: string;
    last_name: string;
    name: string;

    static repo: IRepo<StatusChangeInitiator> = new Repo<StatusChangeInitiator>('StatusChangeInitiators', StatusChangeInitiator);

    constructor(statusAction: LicenseStatusAction) {
        super();
        this.rootModel = statusAction;
        this.parent = statusAction;
        this.defineProperty('client_id', Guid.create());
        this.defineProperty('reference_id', null);
        this.defineProperty('reference_type', null);

        this.defineProperty('first_name', null);
        this.defineProperty('last_name', null);
        this.defineProperty('name', null);

        StatusChangeInitiator.repo.add(this);
        Vue.set(statusAction.status_change_initiators, this.client_id, this);
    }

    update(props) {
        Object.getOwnPropertyNames(props).forEach(key => {
            this[key] = props[key];
        });
    }

    get rootName(): string {
        return 'status_change_initiators';
    }

    get isCollectionRoot(): boolean {
        return true;
    }

    get tagColor(): string {
        return TagColor[this.reference_type];
    }

    get display() {
        switch (this.reference_type) {
            case PermitteeType.originalSubmitter:
                return 'License Holder';
            case PermitteeType.group:
                return this.name;
            case PermitteeType.user:
                return `${this.first_name} ${this.last_name}`;
        }
    }
}
